import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext'; // Added import

type Props = {
  termsAccepted: boolean;
  setTermsAccepted: (value: boolean) => void;
  onNext: () => void;
};

export const TermsStep = ({
  termsAccepted,
  setTermsAccepted,
  onNext,
}: Props) => {
  const { translations } = useLanguage(); // Added hook

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="prose max-w-none">
        <h2 className="text-2xl font-bold mb-4">
          {translations?.terms?.title || 'Acknowledgment & Commitment'}
        </h2>
        <div className="bg-gray-50 p-6 rounded-lg">
          <p className="mb-4">
            {translations?.terms?.acknowledgment ||
              'I, the undersigned, acknowledge and commit to the following:'}
          </p>
          <p className="mb-4">
            {translations?.terms?.compliance ||
              'Compliance with all terms of the marketing services agreement signed with Ithraa Alkhair for Hajj Services.'}
          </p>
          <p className="mb-4">
            {translations?.terms?.provideServices ||
              'Providing marketing services as follows:'}
          </p>
          <ul className="list-inside space-y-2 mb-4">
            <li className="flex items-start gap-2">
              <span className="font-bold">A.</span>
              <span>
                {translations?.terms?.promotePackages ||
                  'Promoting the features of Ithraa Alkhair’s packages and services through digital, social media, events, and exhibitions.'}
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold">B.</span>
              <span>
                {translations?.terms?.encouragePilgrims ||
                  'Encouraging pilgrims to register on the Nusuk Platform and closely monitoring registrations.'}
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold">C.</span>
              <span>
                {translations?.terms?.submitList ||
                  'Submitting a list of pilgrims registered on the Nusuk Platform before the package purchasing phase begins.'}
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold">D.</span>
              <span>
                {translations?.terms?.adhereTo || 'Adhering to the following:'}
              </span>
              <ul className="list-inside space-y-2 mr-6">
                <li>
                  {translations?.terms?.uploadData ||
                    'Uploading pilgrim data within the specified timeframe.'}
                </li>
                <li>
                  {translations?.terms?.ensureAccuracy ||
                    "Ensuring the accuracy of the data and avoiding duplicates or matches with any other guide's data."}
                </li>
                <li>
                  {translations?.terms?.clearMessages ||
                    'Using clear marketing messages that align with religious and cultural values.'}
                </li>
                <li>
                  {translations?.terms?.noComplaints ||
                    'Ensuring no complaints or issues arise regarding the provided services.'}
                </li>
              </ul>
            </li>
          </ul>
          <p className="text-red-600 font-medium">
            {translations?.terms?.legalResponsibility ||
              'Accepting full legal and financial responsibility in case of any breach of the above commitments.'}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={termsAccepted}
          onChange={(e) => setTermsAccepted(e.target.checked)}
          className="rounded text-primary-500 focus:ring-primary-500"
        />
        <label>
          {translations?.terms?.agreeTerms ||
            'I agree to the terms and conditions stated above'}
        </label>
      </div>
      <button
        onClick={onNext}
        disabled={!termsAccepted}
        className="w-full px-4 py-2 bg-primary-500 text-white rounded-lg disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-primary-600 transition-colors"
      >
        {translations?.terms?.next || 'Next'}
      </button>
    </motion.div>
  );
};
